import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2ddf136"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ReleaseProcessing" }
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanField = _resolveComponent("VanField")!
  const _component_VanButton = _resolveComponent("VanButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanField, {
      label: "地区",
      readonly: "",
      modelValue: $setup.submitData.address.join(),
      "is-link": "",
      required: "",
      placeholder: "请选择地区",
      "input-align": "right",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.isShowCityPicker = true)),
      border: false
    }, null, 8, ["modelValue"]),
    _createVNode($setup["CityPicker"], {
      modelValue: $setup.isShowCityPicker,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.isShowCityPicker) = $event)),
      onConfirm: $setup.cityConfirm
    }, null, 8, ["modelValue"]),
    _createVNode(_component_VanField, {
      class: "textarea",
      modelValue: $setup.submitData.profile,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.submitData.profile) = $event)),
      rows: "5",
      autosize: "",
      type: "textarea",
      placeholder: "请填写详细说明",
      "show-word-limit": ""
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_VanButton, {
        type: "primary",
        block: "",
        onClick: $setup.submit,
        color: "#fec64b"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ])
  ]))
}